import { useLocalizeOffsetValues } from '@mews-commander/ui';
import { DurationService, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export interface CancellationPolicyTimingProps {
    applicabilityType: 'Creation' | 'Start' | 'StartDate';
    applicabilityOffset: string;
}

export const useCancellationPolicyTimingGetter = () => {
    const localizeText = useLocalizeText();
    const localizeOffsetValues = useLocalizeOffsetValues();

    return ({ applicabilityType, applicabilityOffset }: CancellationPolicyTimingProps) => {
        const duration = DurationService.parse(applicabilityOffset);
        if (DurationService.isZero(duration)) {
            return localizeText({ textKey: cancellationPolicyApplicabilityTextKeyMap[applicabilityType] });
        }
        if (DurationService.isNegative(duration)) {
            return localizeText({
                textKey: cancellationPolicyApplicabilityWithOffsetBeforeTextKeyMap[applicabilityType],
                substitutes: { offset: localizeOffsetValues(duration) },
            });
        }
        if (DurationService.isPositive(duration)) {
            return localizeText({
                textKey: cancellationPolicyApplicabilityWithOffsetAfterTextKeyMap[applicabilityType],
                substitutes: { offset: localizeOffsetValues(duration) },
            });
        }
    };
};

export const CancellationPolicyTiming = (props: CancellationPolicyTimingProps) => {
    const getCancellationPolicyTiming = useCancellationPolicyTimingGetter();
    return <span>{getCancellationPolicyTiming(props)}</span>;
};

const cancellationPolicyApplicabilityWithOffsetBeforeTextKeyMap = {
    Creation: TextKey.CancellationPolicyApplicabilityCreationWithOffsetBefore,
    Start: TextKey.CancellationPolicyApplicabilityStartWithOffsetBefore,
    StartDate: TextKey.CancellationPolicyApplicabilityStartDateWithOffsetBefore,
};

const cancellationPolicyApplicabilityWithOffsetAfterTextKeyMap = {
    Creation: TextKey.CancellationPolicyApplicabilityCreationWithOffsetAfter,
    Start: TextKey.CancellationPolicyApplicabilityStartWithOffsetAfter,
    StartDate: TextKey.CancellationPolicyApplicabilityStartDateWithOffsetAfter,
};

const cancellationPolicyApplicabilityTextKeyMap = {
    Creation: TextKey.CancellationPolicyApplicabilityConfirmation,
    Start: TextKey.CancellationPolicyApplicabilityCheckInTime,
    StartDate: TextKey.CancellationPolicyApplicabilityArrivalDate,
};
